module.exports = __webpack_public_path__ + "static/media/otm-slack.0d9a0719.png";